import { ReactNode } from "react";
import { CopyButton } from "./CopyButton";

interface CodeBlockProps {
	children?: ReactNode;
	className?: string;
	[key: string]: any;
}

export function CodeBlock({ children, className, ...props }: CodeBlockProps) {
	// Extract the text content for copying
	const getTextContent = (node: ReactNode): string => {
		if (typeof node === "string") return node;
		if (typeof node === "number") return String(node);
		if (Array.isArray(node)) return node.map(getTextContent).join("");
		if (node && typeof node === "object" && "props" in node) {
			return getTextContent(node.props.children);
		}
		return "";
	};

	const textContent = getTextContent(children);

	return (
		<div className="relative group">
			<pre className={className} {...props}>
				{children}
			</pre>
			{textContent && <CopyButton text={textContent} />}
		</div>
	);
}
